// A funtion that accepts a node of richtext and returns a string that can be used as an anchor tag
// Currently used on H tags when defined in rich text options where there is access to the node
// Ex: <h2 id={createAnchorTag(node.content)}>{children}</h2>

interface TextNode {
  nodeType: 'text';
  value: string;
}

export const createAnchorTag = (text: Array<TextNode> | string): string => {
  // create placeholder
  let joinedMarks: string;

  // if argument is a string, use it directly
  if (typeof text === 'string') {
    joinedMarks = text;
    // if argument is an array of text nodes, join their values
  } else {
    joinedMarks = text.map((section) => section.value).join('');
  }

  // then trim to first 8 words, replace spaces with dashes, remove special characters, and convert to lowercase
  const trimmedText = joinedMarks
    .split(' ')
    .slice(0, 8)
    .join('-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase();
  return trimmedText;
};
